/**
 * @description 事件处理，入口文件
 * @author wangfupeng
 */

import statsFn from './stats'
import { query, getTargetUrl } from './query'
import doShare from './share'
import jumpUrl from './location'
import downloadFile from './downloadFile'
import triggerDialog from './dialog'
import dial from './dial'
import jumpAnchor from './anchor'

/**
 * 分别触发各个事件
 * @param {Object} eventData 事件配置
 */
function invokeEvents(eventData = {}) {
    const action = eventData.action
    if (action === 'invokeShare') {
        // 拉起分享
        doShare(eventData)
    }
    if (action === 'location') {
        // 跳转（异步，尽量保证统计打点成功率）
        setTimeout(() => {
            jumpUrl(eventData)
        }, 100)
    }
    if (action === 'download') {
        // 文件下载（异步，尽量保证统计打点成功率）
        setTimeout(() => {
            downloadFile(eventData)
        }, 100)
    }
    if (action === 'dialog') {
        // 触发弹框
        triggerDialog(eventData)
    }
    if (action === 'dial') {
        // 拨号
        dial(eventData)
    }
    if (action === 'anchor') {
        // 锚点（页面位置）
        jumpAnchor(eventData)
    }
}

/**
 * 触发事件的入口
 * @param {Object} eventData 事件配置，格式参考 https://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=239234920 中 eventTable 的一个属性值
 */
function invoke(eventData = {}) {
    // 分析 target 下游链接
    if (eventData.targetUrl) {
        // 如果有 targetUrl ，则直接取来
        eventData.target = eventData.targetUrl
    } else if (eventData.target) {
        // 没有 targetUrl ，试图从 nextUrls 找到链接
        eventData.target = getTargetUrl(eventData.target)
    }

    // 事件统计打点
    try {
        statsFn(eventData)
    } catch (ex) {
        console.error('error in stats')
    }

    // 触发事件执行
    invokeEvents(eventData)
}

/**
 * 自造事件配置，触发事件
 * @param {Object} eventData 事件配置
 */
function customInvoke(eventData = {}) {
    // 拼接
    const defaultEventData = {
        refId: 'dpub3-customInvoke', // id 不传，则默认为一个字符串
        action: 'location',
        actionName: '跳转',
        eventName: 'click',
        name: '点击',
        target: '#', // url 链接
        omegaTrack: 'dpub3-customInvoke-label' // 统计标识
    }
    eventData = Object.assign({}, defaultEventData, eventData)
    // 触发事件执行
    invoke(eventData)
}

export {
    query,
    getTargetUrl,
    invoke,
    customInvoke
}
